import { useMemo } from "react";

import { StudentSentimentChecksQuery } from "@/generated/graphql";

import { SentimentCheckIntervalCard } from "../sentiment-check-interval-card";
import * as styles from "./sentiment-check-list.css";

type SentimentCheckInterval =
  StudentSentimentChecksQuery["studentSentimentChecks"][number];

interface Props {
  intervals: SentimentCheckInterval[];
  onSubmit?: () => void;
}

export function SentimentCheckList({ intervals, onSubmit }: Props) {
  // Sort intervals in reverse order (most recent/highest order first)
  const sortedIntervals = useMemo(
    () => [...intervals].sort((a, b) => b.order - a.order),
    [intervals]
  );

  return (
    <div className={styles.container}>
      {sortedIntervals.map((interval) => (
        <SentimentCheckIntervalCard
          key={interval.order}
          interval={interval}
          onSubmit={onSubmit}
        />
      ))}
    </div>
  );
}
